import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from '../../shared/services/api.service';
import { StorageService } from '../../shared/services/storage.service';
import { CartService } from '../../shared/services/cart.service';

import { Company } from '../../shared/models/company';
import { Pcategory } from '../../shared/models/pcategory';
import { Product } from '../../shared/models/product';
import { ProductOrder } from '../../shared/models/product-order';

import { StringHelpers } from '../../shared/helpers/string-helpers';
import { Utils } from '../../shared/helpers/utils';

import { CartComponent } from './cart/cart.component';

import { faUtensils, faSearch } from '../../icons';

import * as smoothscroll from 'smoothscroll-polyfill';

@Component({
    selector: 'app-restaurant-menu',
    templateUrl: './restaurant-menu.component.html',
    styleUrls: ['./restaurant-menu.component.scss'],
    standalone: false
})
export class RestaurantMenuComponent implements OnInit {
  @ViewChild('cart') cartEl: CartComponent;

	restaurant: Company;
	pcategories: Pcategory[];
	selectedProduct: Product;
  isPizza: boolean;
  pizzaCategories: Pcategory[] = [];

  deparameterize = StringHelpers.deparameterize;

  product_name_search: string = '';

  scrollY: number;
  pcategoriesOffset: {el: HTMLElement, offset: number}[] = [];
  scrolling: boolean = false;

  faUtensils = faUtensils;
  faSearch = faSearch;

  constructor(private route: ActivatedRoute,
  	private api: ApiService,
    private storageServ: StorageService,
    private cartServ: CartService) { }

  ngOnInit(): void {
    smoothscroll.polyfill();
  	this._loadRestaurant();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let els = document.getElementsByTagName("app-products-list");
      for(let i = 0; i < els.length; i++) {
        let el: HTMLElement = <HTMLElement>els[i];
        this.pcategoriesOffset.push({el: el, offset: el.offsetTop});
      }
    }, 2200);
  }

  // product-order object or null, in case user didn't
  // want to add item to cart
  onItemAdded(item: ProductOrder) {
    this.selectedProduct = null;
  }

  selectProduct(product: Product) {
    let pcat: Pcategory = Utils.findById(product.pcategory_id, this.pcategories);
    this.isPizza = !!(pcat && pcat.isPizza && this.restaurant && this.restaurant.parsedPizzaConfig);
    
    this.selectedProduct = product;
  }

  backTriggered() {
    this.selectedProduct = null;
  }

  pageScroll(scrollY) {
    this.scrollY = scrollY;

    if(this.pcategoriesOffset.length == 0 || this.scrolling)
      return;
    
    this._setActiveBadge();
  }

  scrollToPcategory(pcategory: Pcategory, index: number) {
    this.scrolling = true;
    let el = document.getElementById("pcat-" + pcategory.id);
    el.scrollIntoView({behavior: 'smooth'});
  }

  stoppedScrolling() {
    this.scrolling = false;
    this._setActiveBadge();
  }

  private _loadRestaurant() {
  	this.route.paramMap.subscribe(params => {
  		let name = params.get("restaurant_name");
  		this.api.show('companies', name).subscribe(
  			res => {
  				Company.setAdditionalData(res.company);

          if(!res.company.delivery_hours) {
            alert("O ESTABELECIMENTO NÃO INFORMOU HORÁRIO DE FUNCIONAMENTO");
            return;
          }

          this.restaurant = res.company;

          let existing = this.storageServ.getInLocal('current_company');
          if(existing && existing.id != this.restaurant.id) {
            this.cartServ.clear();
          }

          this.storageServ.storeInLocal('current_company', this.restaurant);
  				this._loadPcategories();
  			},
  			err => {
  				alert(`Não foi possível obter informações do restaurante ${name}. Por favor verifique o nome`);
  				console.error(err);
  			}
  		);
  	});
  }
  private _loadPcategories() {
  	this.api.indexAll('pcategories', {
  		q: {
  			company_id: this.restaurant.id,
  			hidden: false,
  			delivery: true
  		}
  	}).subscribe(
  		res => {
        Pcategory.setArrayAdditionalData(res.pcategories);
        let visiblePcategories = [];
        for(let pcat of res.pcategories) {
          if(pcat.isOnSchedule) {
            visiblePcategories.push(pcat);
          }
        }

  			this.pcategories = Pcategory.sortByDisplayOrder(visiblePcategories, 'delivery');
        this._loadPizzaFlavorProducts();
  		},
  		err => {
  			alert(`Não foi possível obter as categorias de produto do restaurante ${name}. Por favor, faça seu pedido diretamente com eles.`);
  			console.error(err);
  		}
  	);
  }
  private _loadPizzaFlavorProducts() {
    this.pizzaCategories = (this.pcategories || []).filter(c => c.isPizza);
    for(let pcat of this.pizzaCategories) {
      this.api.indexAll('products', {
        q: {
          pcategory_id: pcat.id,
          hidden: false,
          delivery: true
        }
      }).subscribe(
        res => {
          Product.setArrayAdditionalData(res.products);
          pcat.products = res.products;
        },
        err => {
          console.error(err);
        }
      );
    }
  }
  private _setActiveBadge(index = null) {
    if(this.pcategoriesOffset.length == 0) {
      return;
    }
    
    if(index == null) {
      for(let i = this.pcategories.length - 1; i >= 0 ; i--) {
        if(this.scrollY > this.pcategoriesOffset[i].offset) {
          index = i;
          break;
        }
      }
    }

    this._setActiveBadgeByIndex(index);
    this._scrollIntoPcategoriesList(index);
  }
  private _setActiveBadgeByIndex(index) {
    for(let i = this.pcategories.length - 1; i >= 0 ; i--) {
      if(i == index)
        this.pcategories[i].is_active = true;
      else
        this.pcategories[i].is_active = false;
    }
  }
  private _scrollIntoPcategoriesList(index) {
    let el: HTMLElement = <HTMLElement>document.getElementsByClassName("pcategory-badge")[index];
    if(el)
      el.parentElement.scroll(el.offsetLeft - 100, 0);
  }
}
